import { render, staticRenderFns } from "./SchoolDemoLog.vue?vue&type=template&id=04e31783"
import script from "./SchoolDemoLog.vue?vue&type=script&lang=ts"
export * from "./SchoolDemoLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports